export const SCROLL_TARGET = 'hotelHeader';
